import React from 'react'
import { StyledQtyContainer } from './QuantityWmo.css'
import QuantitySelectorWmo from './QuantitySelectorWmo'
import constants from '../../../../constants'

const QuantityWMO = ({
  data, index, setQuantity,
}) => (
  <StyledQtyContainer>
    <QuantitySelectorWmo
      selectedValue={data.modifiers.quantity}
      maxQuantity={data.inventory.quantity <= constants.MAX_QUANTITY ? data.inventory.quantity : constants.MAX_QUANTITY}
      setSelectedValue={setQuantity}
      index={index}
      disabled={data.inventory.quantity < 1}
    />
  </StyledQtyContainer>
)

export default QuantityWMO
